//src/production/components/ProductWiseMachine.jsx :-
import React, { useState, useEffect } from "react";
import TableTemplate from "./TableTemplate";
import AddEditProductWiseMachine from "./AddEditProductWiseMachine";
import { Button, Box, Drawer } from "@mui/material";
import axios from "axios";
import env from "react-dotenv";

const ProductWiseMachine = () => {
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [expandedDrawer, setExpandedDrawer] = useState(false); // State for drawer expansion

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productwisemachine`);
            setData(response.data[0]);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleAdd = () => {
        setEditData(null);
        setOpen(true);
        setExpandedDrawer(false); // Reset to not expanded when adding a new entry
    };

    const handleEdit = (item) => {
        setEditData(item);
        setOpen(true);
        setExpandedDrawer(false); // Reset to not expanded when editing
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productwisemachine/${id}`);
            setData(data.filter(item => item.id !== id));
        } catch (error) {
            console.error("Error deleting record:", error);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setExpandedDrawer(false); // Reset drawer expansion on close
    };

    const handleSave = async (item) => {
        try {
            if (item.id) {
                await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productwisemachine/${item.id}`, item);
            } else {
                await axios.post(`${process.env.REACT_APP_PJCBACKEND_URL}/api/productwisemachine`, item);
            }
            fetchData();
        } catch (error) {
            console.error("Error saving record:", error);
        }
        setOpen(false);
        setExpandedDrawer(false); // Reset drawer expansion on save
    };

    const handleExpandDrawer = () => {
        setExpandedDrawer(true); // Set to true when expanding the drawer
    };

    return (
        <Box
        sx={{
            height: 670,
            width: '85%',
            marginLeft:"210px",
            marginRight:"150px",
          }}
        >
            <TableTemplate
                columns={["section_name", "process_name", "product_name", "RM_name", "machine_name", "quantity", "elect_unit", "elect_cost", "manpower", "manpower_cost", "manpower_cost_per_unit", "elect_cost_per_unit", "cost_unit"]}
                headers={{
                    columns: ["Section", "Process", "Product", "Raw Material", "Machine", "Quantity", "Electricity", "Electricity Cost", "Manpower", "Manpower Cost", "Manpower Cost/Unit", "Electricity Cost/Unit", "InCost/Unit"]
                }}
                iterate={data}
                data={data}
                onDelete={handleDelete}
                onEdit={handleEdit}
                onAdd={handleAdd}
                add
                edit
            />

            {/* Drawer for Add/Edit Form */}
            <Drawer
                anchor="right"
                open={open}
                onClose={handleClose}
                sx={{
                    "& .MuiDrawer-paper": { width: expandedDrawer ? "800px" : "600px" } // Expand when form is open
                }}
            >
                <AddEditProductWiseMachine 
                    onClose={handleClose} 
                    onSave={handleSave} 
                    editData={editData} 
                    onExpandDrawer={handleExpandDrawer} // Pass the expand function to the child component
                />
            </Drawer>
        </Box>
    );
};

export default ProductWiseMachine;